import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { ServiceCard } from "../components/site/ServiceCard";
import { CTASection } from "../components/site/CTASection";
import { FAQ, ProseSection } from "../components/site/SeoContent";
import { SERVICES_PROSE, SERVICES_FAQ } from "../lib/seoContent";
import { usePageMeta } from "../components/site/SmoothScroll";
import { SERVICES, IMAGES, PHONE_TEL } from "../lib/site";

export default function Services() {
  usePageMeta(
    "Astrology, Psychic, Tarot & Palm Reading Services in Calgary | Astrologer & Spiritual Healers",
    "Explore our services in Calgary: Vedic astrology, horoscope and psychic readings, tarot card reading, palm reading, love, career and marriage guidance, and spiritual healing."
  );
  return (
    <main data-testid="services-page">
      <PageHero
        testId="services-hero"
        eyebrow="Our Services"
        image={IMAGES.cosmic}
        lines={[{ text: "Eleven paths" }, { text: "to clarity", className: "italic gold-text" }]}
        intro="From Vedic astrology and tarot to palm reading and spiritual healing, each service is tailored to your questions. Choose a reading below, or reach out and we'll help you decide."
      />
      <section className="px-5 pb-10 sm:px-8 lg:px-12">
        <div data-testid="services-grid" className="mx-auto grid max-w-[1400px] gap-4 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => <ServiceCard key={s.id} service={s} index={i} />)}
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: 0.16 }}
            className="flex flex-col justify-between border border-[#D4AF37]/50 bg-[#D4AF37] p-7 text-[#07040D] sm:p-8">
            <span className="font-cinzel text-xs tracking-[0.25em]">12 — UNSURE?</span>
            <div>
              <h3 className="font-display mt-10 text-3xl leading-tight">Not sure which reading is right for you?</h3>
              <p className="mt-4 text-sm leading-relaxed text-[#1b1430]">Tell us what's on your mind and we'll recommend the most helpful session.</p>
            </div>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/book" data-testid="services-unsure-book" className="rounded-full bg-[#07040D] px-5 py-2.5 text-sm text-[#F3E5AB] transition-transform duration-300 hover:-translate-y-0.5">Book a consultation</Link>
              <a href={PHONE_TEL} data-testid="services-unsure-call" className="inline-flex items-center gap-2 rounded-full border border-[#07040D]/40 px-5 py-2.5 text-sm"><Phone className="h-4 w-4" /> Call</a>
            </div>
          </motion.div>
        </div>
      </section>
      <ProseSection testId="services-prose" eyebrow="Astrology & Psychic Services in Calgary" title="Guidance for every part of life" paragraphs={SERVICES_PROSE} />
      <FAQ testId="services-faq" items={SERVICES_FAQ} />
      <CTASection />
    </main>
  );
}
